import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/resume-score/ResumeScoreContent.tsx");
